import { useEffect } from 'react';
import styles from './EmailVerifyConfirm.module.css';

interface Props {
  onDone: () => void;
}

export function EmailVerifyConfirm({ onDone }: Props) {
  useEffect(() => {
    const timer = window.setTimeout(() => {
      if (window.location.hash) {
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }
      onDone();
    }, 2000);
    return () => window.clearTimeout(timer);
  }, [onDone]);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.title}>Email verified</h1>
        <p className={styles.subtitle}>Welcome to Neume. Redirecting…</p>
      </div>
    </div>
  );
}
